import { storedItem } from "../storedItem"

export class nzaaArchaeologicalSite extends storedItem {
	displayName() {
		const that: any = this
		return that.name && that.name.length > 0 ? that.name : `${that.site_type} ${that.nzaa_id}`
	}
}
